export default __webpack_public_path__ + "static/group-business-e6ea18775a4f8b51aed2d073ec4a8e90.jpg";